/**
 * How far back the activity feed queries. Read-state is pruned to the same
 * horizon: once an event falls outside this window the server stops returning
 * it, so it can never render again and its read mark is dead weight.
 */
export const ACTIVITY_WINDOW_MS = 30 * 24 * 60 * 60 * 1000;
